import React, { Fragment, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ActionButton } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 25);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-97" data-mp="20s3ap5qqzf4w">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-98" data-mp="3h6v3vkvpwqf9">
        <div className="mx-auto max-w-4xl text-center" data-id="element-99" data-mp="3h9hclnuchbz2">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-100" data-mp="3c78j8qdk87wf">PRECIO DE LANZAMIENTO — CIERRA PRONTO</h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-101" data-mp="3vynisgb71zbg">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-102" data-mp="9q5r1m2sa8om" data-mpi={index}>
                <div data-id="element-103" data-mp="erv6ddx1h8ii">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-104" data-mp="eqabfn6tbnk4">{value}</p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-105" data-mp="3da0ieb3ypy47">{label}</p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-106" data-mp="3i8k5ieualfy5">:</span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-107" data-mp="3rxljjzha1n9h">
            Después sube. <b className="text-white" data-id="element-108" data-mp="3rz6f9sfbvc8x">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-109" data-mp="2uhep9ykfwlnb">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-110" data-mp="2zfzopvrvb1ap">
              <span data-id="element-111" data-mp="2rftf2huvdvit">Cupos al precio de lanzamiento</span>
              <span data-id="element-112" data-mp="2mhrsvo25dg34">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-113" data-mp="2mh8o791ico71">
              <div className="h-full w-[68%] rounded-full bg-red-500" data-id="element-114" data-mp="315mopdbgc0kf" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-115" data-mp="2w7bev2l5pq27">68% de los cupos ya tomados</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-116" data-mp="28i8xlvufpz88">
        <div className="mx-auto max-w-2xl" data-id="element-117" data-mp="23jfk43f5e882">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-118" data-mp="23kgwqcbtb2rw">TU SISTEMA COMPLETO</h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-119" data-mp="2ihhp8i1tv1rf">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-120" data-mp="3ovqunrc44cel">
              <div data-id="element-121" data-mp="9m0obr0ji81">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-122" data-mp="92ictxgarth">🌿 PROTOCOLO ABDOMEN LIVIANO™</h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-123" data-mp="57dtd7zhf8da">5 Volúmenes + 5 Bonos · Acceso inmediato</p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-124" data-mp="3nhfwxv02rkl4">Tu protocolo completo en PDF más 5 bonos estratégicos de regalo.</p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-125" data-mp="j1wl8phsuthc">
                <p className="text-slate-500 line-through" data-id="element-126" data-mp="j37s4y6jkhco">$55.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-127" data-mp="nz6k0vr2whhu">$19.990</p>
                <p className="text-xs text-slate-400" data-id="element-128" data-mp="a81redm4oph0">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" showTrust data-id="element-129" data-mp="e8267zd532ol">
            🌿 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}